import { render, staticRenderFns } from "./BaseInputField.vue?vue&type=template&id=4d7485f4&scoped=true&"
import script from "./BaseInputField.vue?vue&type=script&lang=js&"
export * from "./BaseInputField.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputField.vue?vue&type=style&index=0&id=4d7485f4&prod&lang=scss&scoped=true&"
import style1 from "./BaseInputField.vue?vue&type=style&index=1&id=4d7485f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7485f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InformationCircle: require('/vercel/path0/components/icons/InformationCircle.vue').default,TransitionExpand: require('/vercel/path0/components/TransitionExpand.vue').default})
